import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import QuoteCalculator from "@/components/QuoteCalculator";
import Trust from "@/components/Trust";
// import Team from "@/components/Team";
import Reviews from "@/components/Reviews";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <QuoteCalculator />
        <Trust />
        {/* <Team /> */}
        <Reviews />
        <ContactForm />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
